import React from "react";

const PageContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className="justify-center items-center p-4 md:p-8 lg:p-12">
      {children}
    </div>
  );
};

export default PageContainer;
